import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import useEscHandler from '@/lib/hooks/useEscHandler';
import translate from '@/lib/intl/translate';

function LifeycleColumnForm({
  columnDescription,
  columnTitle,
  onCancelUpdate,
  onClose,
  onSubmit,
}) {
  const closeWithoutSaving = () => {
    onClose();
    onCancelUpdate();
  };

  useEscHandler(closeWithoutSaving);

  const { control, formState, handleSubmit } = useForm({
    defaultValues: { columnDescription, columnTitle },
  });

  const { errors } = formState;

  const submit = async (data) => {
    if (formState.isSubmitting) return;
    await onSubmit(data);
    onClose();
  };

  return (
    <form
      autoComplete="off"
      className="flex w-full flex-col gap-3"
      onSubmit={handleSubmit(submit)}
      noValidate
      data-testid="lifecycle-column-form"
    >
      <Controller
        name="columnTitle"
        control={control}
        rules={{ required: translate('FORMS_VALIDATION_REQUIRED_LONG') }}
        render={({ field }) => (
          <TextField
            fullWidth
            error={!!errors.columnTitle}
            helperText={errors?.columnTitle?.message || ''}
            required
            label={translate('BOARD_COLUMN_TITLE')}
            {...field}
          />
        )}
      />
      <Controller
        name="columnDescription"
        control={control}
        render={({ field }) => (
          <TextField
            fullWidth
            label={translate('BOARD_COLUMN_DESCRIPTION')}
            multiline
            {...field}
          />
        )}
      />
      <div className="min-h flex items-center justify-end">
        <Button
          type="button"
          className="h-12"
          onClick={closeWithoutSaving}
          size="small"
        >
          {translate('CANCEL')}
        </Button>
        <Button
          type="submit"
          className="h-12"
          size="small"
          color="primary"
          variant="contained"
          disabled={formState.isSubmitting}
        >
          {translate('SAVE')}
        </Button>
      </div>
    </form>
  );
}

LifeycleColumnForm.propTypes = {
  columnDescription: PropTypes.string,
  columnTitle: PropTypes.string,
  onCancelUpdate: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

LifeycleColumnForm.defaultProps = {
  columnDescription: '',
  columnTitle: '',
  onCancelUpdate: () => {},
  onClose: () => {},
  onSubmit: () => {},
};

export default LifeycleColumnForm;
